import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ChevronIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-right';
import {
  BpkFlex,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import type { StringTranslations } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './PriceButton.module.scss';

const ChevronArrow = withRtlSupport(ChevronIcon);

type PriceButtonProps = {
  strings: StringTranslations;
  price: string;
};

const PriceButton = ({ price, strings }: PriceButtonProps) => {
  const buttonText = reactReplacePlaceholder(
    strings.component_deals_evolved_cta,
    {
      price,
    },
    '{',
    '}',
  ).join('');
  return (
    <BpkVessel className={STYLES.PriceButton__button}>
      <BpkFlex align="center" shrink={0}>
        <BpkText textStyle={TEXT_STYLES.label1}>{buttonText}</BpkText>
        <BpkVessel className={STYLES.PriceButton__buttonArrow}>
          <BpkFlex>
            <ChevronArrow />
          </BpkFlex>
        </BpkVessel>
      </BpkFlex>
    </BpkVessel>
  );
};

export default PriceButton;
